import React, { useEffect } from 'react';
import styles from './ConversationLength.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useFetch } from 'hooks/useFetch';
import { dashboardEndpoints } from 'hooks/endpoints';

const truncate2 = (n) => (((n ?? 0) * 100) | 0) / 100;

const ConversationLength = ({ startDate, endDate, botId }) => {
  const { data, refetch } = useFetch(
    ['conversationLength', startDate, endDate, botId],
    dashboardEndpoints.getAverageConversationLength(startDate, endDate),
    { enabled: false },
    botId ? { botId: botId } : {}
  );

  useEffect(() => {
    refetch();
  }, [startDate, endDate]);

  const currentAvg = data?.data?.currentWindow?.averageSeconds ?? 0;
  const prevAvg = data?.data?.previousMonthWindow?.averageSeconds ?? 0;

  let changePctTrunc = 0;
  let isPositive = false;
  let isNegative = false;

  if (prevAvg === 0) {
    if (currentAvg > 0) {
      changePctTrunc = 100;
      isPositive = true;
    } else {
      changePctTrunc = 0;
    }
  } else {
    const changePct = ((currentAvg - prevAvg) / prevAvg) * 100;
    changePctTrunc = Math.trunc(changePct * 100) / 100;
    isPositive = changePctTrunc > 0;
    isNegative = changePctTrunc < 0;
  }

  const showArrow = changePctTrunc !== 0;

  const color = isNegative ? '#DB161B' : isPositive ? '#01931A' : '#F08800';
  const backgroundColor = isNegative
    ? '#FBE3E4'
    : isPositive
    ? '#E0FFE5'
    : '#FFF7EC';
  const arrowRotation = isPositive ? 'rotate(180deg)' : 'none';

  const formatPercent = (val, sign) => {
    const num = Math.abs(val);
    const str = Number.isInteger(num) ? num : num.toFixed(2);
    return sign + str + '%';
  };

  return (
    <div className={styles['conversation-length-container']}>
      <div className={styles['title-description-container']}>
        <div className={styles['title-container']}>
          <SvgWithBranding type='conversationLength' />
          <span className={styles['title']}>Conversation Length</span>
        </div>
        <span className={styles['description']}>
          Average duration of a user-chatbot interaction from start to finish.
        </span>
      </div>
      <span className={styles['duration-time']}>
        {data?.data?.currentWindow?.averageFormatted}
      </span>
      <div className={styles['chart-container']}>
        <SvgWithBranding type='lineChart' className={styles['line-chart']} />
        <div className={styles['percentage-change-container']}>
          <div
            className={styles['percentage-card']}
            style={{ color, backgroundColor, borderColor: color }}
          >
            {showArrow && (
              <div style={{ transform: arrowRotation }}>
                <SvgWithBranding type='down_arrow' color={color} height={12} />
              </div>
            )}
            <span className={styles['percentage-change']} style={{ color }}>
              {isPositive
                ? formatPercent(changePctTrunc, '+')
                : isNegative
                ? formatPercent(changePctTrunc, '-')
                : formatPercent(changePctTrunc, '')}
            </span>
          </div>
          <span className={styles['duration']}>from last month</span>
        </div>
      </div>
    </div>
  );
};

export default ConversationLength;
